import { createFileRoute } from "@tanstack/react-router";
import { SpringsLandingPage, buildSpringsLandingHead } from "@/components/SpringsLandingPage";
import { getSpringsLandingConfig } from "@/lib/springsLandingData";

const CONFIG = getSpringsLandingConfig("colorado-springs-garage-door-seo");

export const Route = createFileRoute("/colorado-springs-garage-door-seo")({
  head: () => buildSpringsLandingHead(CONFIG),
  component: () => <SpringsLandingPage config={CONFIG} />,
});
